import React         from 'react';
import ReactDom      from 'react-dom';

import Const         from 'fw_const';
import Utils         from 'utils';
const median = (arr) => {
  if (!arr || arr.length === 0) return 0;
  const sorted = [...arr].sort((a, b) => a - b);
  const mid = Math.floor(sorted.length / 2);
  return sorted.length % 2 !== 0 ? sorted[mid] : (sorted[mid - 1] + sorted[mid]) / 2;
};
// -------------------------------------------------------

class AchievementsAvg extends React.Component {
  render() {
    let data = this.props.data;
    let projects = this.props.projects;
    
    let modeList = [
      { id: 'reach', name: 'リーチ数' },
      { id: 'likes', name: 'いいね数' },
      { id: 'plays', name: '再生数' },
    ];
    
    let modeObj = '';
    modeList.map((d) => { if( d.id == this.props.mode ) modeObj = d; });
    
    // カラムリスト
    let scoreColumns = [
      //{ id: 'post_count',     name: '投稿数',                       fmt: 'int' },
      { id: 'score',          name: modeObj.name,                      fmt: 'int' },
      { id: 'contract_money', name: '報酬',                            fmt: 'int' },
      { id: 'cp',             name: '1'+ modeObj.name +'あたりの単価', fmt: 'float' },
    ];
    
    // 平均スコア
    let avg = { score: [], contract_money: [], cp: [] };
    projects.map((d) => {
      scoreColumns.map((c) => {
        if( c.id == 'score'){
          d.reports.map((r) => { avg.score.push(r[modeObj.id]); });
        } else {
          if( d.post_count > 0 && d.contract_money > 0 ) avg[c.id].push(d[c.id]);
        }
      });
    });
    
    let avgObj = {};
    for( let i in avg ) avgObj[i] = median(avg[i]);
    
    return (
      <div className="achievements-avg">
        <h2>平均スコア</h2>
        <h5>運用結果のレポートから平均を算出した値になります</h5>
        
        <div className="achievements-report-score">
          { scoreColumns.map((c, ckey) => {
            if( isNaN(avgObj[c.id]) || avgObj[c.id] == 'Infinity' ) avgObj[c.id] = 0;
            
            return (
              <div key={ckey} className="item">
                <h6>{c.name}</h6>
                { (c.fmt == 'int') && <p>{Utils.viewInt(avgObj[c.id])}</p> }
                { (c.fmt == 'float') && <p>{avgObj[c.id].toFixed(1)}</p> }
              </div>
            );
          })}
        </div>
      </div>
    );
  }
}
// -------------------------------------------------------

// レンダリング処理
export default AchievementsAvg;